module.exports = __webpack_public_path__ + "img/IMG_20191127_000107.ccdefb96.jpg";